module.exports = __webpack_public_path__ + "static/media/Propuesta_de_Amparo_Datos_Personales_MAF_y_Asociados.b55b86f9.pdf";